const layerGround = [
  //------------------------------------------------------------------------Ligne1
  [
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleRight",
        name: "angleRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne2
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne3
  [
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne4
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne5
  [
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne6
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "bush",
          name: "bush",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne7
  [
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminCroisement",
        name: "cheminCroisement",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminVertical",
        name: "cheminVertical",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminVertical",
        name: "cheminVertical",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleRight",
        name: "angleRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne8
  [
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
     {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne9
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "ground",
          name: "ground",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne10
  [
    {
      type: "GroundSprite",
      args: {
        texture: "angleLeft",
        name: "angleLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleDown",
        name: "angleDown",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleLeft",
        name: "angleLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleLeft",
        name: "angleLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne11
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne12
  [
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {type: "GroundSprite",
    args: {
      texture: "longueurTopRight",
      name: "longueurTopRight",
      isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleRight",
        name: "angleRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "ground",
        name: "ground",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleRight",
        name: "angleRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne13
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne14
  [
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleRight",
        name: "angleRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleDown",
        name: "angleDown",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne15
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
     {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
      {
        type: "GroundSprite",
        args: {
          texture: "bush",
          name: "bush",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne16
  [
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleTop",
        name: "angleTop",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne17
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminHorizon",
          name: "cheminHorizon",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne18
  [
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopLeft",
        name: "longueurTopLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurTopRight",
        name: "longueurTopRight",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "bush",
        name: "bush",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleDown",
        name: "angleDown",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "cheminHorizon",
        name: "cheminHorizon",
        isWalkable: true
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownRight",
        name: "longueurDownRight",
        isWalkable: false
      }
    }
  ],
    //------------------------------------------------------------------------Ligne19
    [
      {
        type: "GroundSprite",
        args: {
          texture: "longueurTopLeft",
          name: "longueurTopLeft",
          isWalkable: false
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminVertical",
          name: "cheminVertical",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "cheminCroisement",
          name: "cheminCroisement",
          isWalkable: true
        }
      },
      {
        type: "GroundSprite",
        args: {
          texture: "longueurDownRight",
          name: "longueurDownRight",
          isWalkable: false
        }
      }
    ],
      //------------------------------------------------------------------------Ligne20
  [
    {
      type: "GroundSprite",
      args: {
        texture: "angleLeft",
        name: "angleLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "longueurDownLeft",
        name: "longueurDownLeft",
        isWalkable: false
      }
    },
    {
      type: "GroundSprite",
      args: {
        texture: "angleDown",
        name: "angleDown",
        isWalkable: false
      }
    }
  ],
    
];
export default layerGround;
